import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, Calculator, Home } from "lucide-react";

import { AdminPage } from "@/components/admin/AdminSidebar";
import { Card, CardContent } from "@/components/ui/card";
import { useUserRoles } from "@/hooks/use-user-roles";

export const Route = createFileRoute("/admin/herramientas")({
  head: () => ({
    meta: [{ title: "Herramientas — Admin" }, { name: "robots", content: "noindex,nofollow" }],
  }),
  component: HerramientasPage,
});

const HERRAMIENTAS = [
  {
    to: "/admin/estimador",
    icon: Calculator,
    titulo: "Valorador de negocios",
    texto:
      "Valor de traspaso, venta o alquiler de un local o negocio con comparables publicados en Bizaclia y datos del negocio.",
  },
  {
    to: "/admin/estimador-vivienda",
    icon: Home,
    titulo: "Estimador de vivienda",
    texto:
      "Precio de venta o alquiler de un piso o casa con anuncios comparables de la zona, alquiler y rentabilidad.",
  },
] as const;

function HerramientasPage() {
  const { roles } = useUserRoles();
  const isAdmin = (roles ?? []).includes("admin");

  if (!isAdmin) {
    return (
      <AdminPage title="Herramientas">
        <p className="text-sm text-muted-foreground">
          Estas herramientas solo están disponibles para administradores.
        </p>
      </AdminPage>
    );
  }

  return (
    <AdminPage title="Herramientas" description="Valoradores de Bizaclia. Elige cuál quieres usar.">
      <div className="grid gap-4 sm:grid-cols-2">
        {HERRAMIENTAS.map((h) => (
          <Link key={h.to} to={h.to} className="group">
            <Card className="h-full transition-colors group-hover:border-primary">
              <CardContent className="flex h-full flex-col gap-3 p-6">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">
                  <h.icon className="h-5 w-5" />
                </span>
                <span className="text-base font-semibold">{h.titulo}</span>
                <span className="flex-1 text-sm text-muted-foreground">{h.texto}</span>
                <span className="flex items-center gap-1 text-sm font-medium text-primary">
                  Abrir{" "}
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </AdminPage>
  );
}
